import { render, staticRenderFns } from "./icon-arrow-long-rounded.vue?vue&type=template&id=dc225498&scoped=true&"
import script from "./icon-arrow-long-rounded.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-long-rounded.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow-long-rounded.vue?vue&type=style&index=0&id=dc225498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc225498",
  null
  
)

export default component.exports